import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-cliente-analise-financeira-status-badge',
    templateUrl: './cliente-analise-financeira-status-badge.component.html',
    styleUrls: ['./cliente-analise-financeira-status-badge.component.less']
})
export class ClienteAnaliseFinanceiraStatusBadgeComponent {
    @Input() status: number;
}
